"use strict";
var lib_core = require("lib-core");
var editor_2d = require("editor-2d");

var drawSymbolTerminalDataTo2D = require("./../../../shared/renderData/drawSymbolTerminalDataTo2D.js");

var SymbolGeneratorInteractionView = function (gui, interactionModel, parentGroup, layers) {
    var self = this;
    this.gui = gui;
    this.interactionModel = interactionModel;
    this.data = this.interactionModel.data;

    this.cameraModel = this.gui.editorModel.cameraModel();

    this.initGroups(parentGroup, [layers.draw, layers.control]);

    this.elementSvgGroup = this.getGroupInfo(layers.draw).svgGroup;
    this.controlGroup = this.getGroupInfo(layers.control).svgGroup;

    this.handle = new editor_2d.HandleView(self, this.gui, 0, this.interactionModel.handle(), parentGroup, layers);

    $(this.controlGroup).mousedown(function(event){
        return self.onMouseDown(event);
    });

    this.draw();

    this.data.leftNameList.onBubble("leftNameListChanged", function () {
        if(self.data.isAlive()) self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.draw, self, [], self);
    }, 10);
    this.data.bottomNameList.onBubble("bottomNameListChanged", function () {
        if(self.data.isAlive()) self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.draw, self, [], self);
    }, 10);
    this.data.rightNameList.onBubble("rightNameListChanged", function () {
        if(self.data.isAlive()) self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.draw, self, [], self);
    }, 10);
    this.data.topNameList.onBubble("topNameListChanged", function () {
        if(self.data.isAlive()) self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.draw, self, [], self);
    }, 10);

     this.data.height.onChange("heightChanged", function () {
        if(self.data.isAlive()) self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.draw, self, [], self.data.height);
    }, 10);
    this.data.width.onChange("widthChanged", function () {
        if(self.data.isAlive()) self.gui.heavyHandler.scheduleHeavy('rebuild_view', self.draw, self, [], self.data.height);
    }, 10);

    this.data.pos.onChange("positionChanged", function () {
        if(self.data.isAlive()) self.gui.heavyHandler.scheduleHeavy('transform_view', self.setSymbolGeneratorTransform, self, [], self);
    }, 10);
    this.data.angle.onChange("angleChanged", function () {
        if(self.data.isAlive()) self.gui.heavyHandler.scheduleHeavy('transform_view', self.setSymbolGeneratorTransform, self, [], self);
    }, 10);

    this.interactionModel.selected.onChange(self, function(value, old){
        if (self.interactionModel.isAlive()) self.setSelected(value);
    },10);
};
lib_core.mixin(SymbolGeneratorInteractionView, editor_2d.DrawingElement);

module.exports = SymbolGeneratorInteractionView;

SymbolGeneratorInteractionView.prototype.draw = function () {
    var self = this;

    $(this.elementSvgGroup).empty();
    $(this.controlGroup).empty();

    if(!this.data.isAlive()) return;

    var elements = this.data.getElements();
    editor_2d.drawRectangleDataTo2D(this.gui.svg, this.elementSvgGroup, elements.rectangle);

    editor_2d.drawRectangleDataTo2D(this.gui.svg, this.controlGroup, elements.rectangle);
    var control = $(this.controlGroup);
    control.attr("stroke-width", elements.rectangle.strokeWidth() + 4 / self.cameraModel.viewS());


    // draw terminals
    for (var i = 0; i <elements.terminals.length; i++){
        this.drawTerminal(elements.terminals[i], elements.labels[i], elements.lines[i], i);
    }

    self.setSymbolGeneratorTransform();
};

SymbolGeneratorInteractionView.prototype.setSymbolGeneratorTransform = function () {
    var self = this;

    this.groupInfos.forEach(function (index, groupInfo) {
        var transform = 'translate(' + (self.data.pos().x)  + ',' + (self.data.pos().y) + ')';
        if (groupInfo.rotate)
            transform += ' rotate(' + self.data.angle() + ')';

        if (groupInfo.transform)
            self.gui.svg.change(groupInfo.svgGroup, {'transform':transform});
    });
};

SymbolGeneratorInteractionView.prototype.drawTerminal = function (terminal, label, line, terminalIndex) {
    var self = this;
    
    var group = this.gui.svg.group(this.elementSvgGroup);
    editor_2d.drawTextDataTo2D(this.gui.svg, group, label);
    editor_2d.drawLineDataTo2D(this.gui.svg, group, line);
    drawSymbolTerminalDataTo2D(this.gui.svg, group, terminal);

    var controlGroup = this.gui.svg.group(this.controlGroup);
    editor_2d.drawTextDataTo2D(this.gui.svg, controlGroup, label);
    editor_2d.drawLineDataTo2D(this.gui.svg, controlGroup, line);
    drawSymbolTerminalDataTo2D(this.gui.svg, controlGroup, terminal);

    // add to svg and control layer
    var control = $("> :last-child",this.controlGroup).last();
    control.attr("stroke-width", 2 + 4 / this.cameraModel.viewS());
    var terminalInteractionModel = this.interactionModel.terminalInteractionModelList.get(terminalIndex);
    control.mousedown(function(event){
        return self.onTerminalMouseDown(event, terminalInteractionModel);
    });
};

SymbolGeneratorInteractionView.prototype.onMouseDown = function (event) {
    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.ELEMENT_MOUSE_DOWN)
        .fromJSEvent(event)
        .element( this.interactionModel )
        .data( 'mouseCoord', this.gui.relativeMouseCoord(event) );

    return this.gui.stateMachine.handle(cEvent);
};

SymbolGeneratorInteractionView.prototype.onTerminalMouseDown = function (event, terminalInteractionModel) {
    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.ELEMENT_MOUSE_DOWN)
        .fromJSEvent(event)
        .element( this.interactionModel )
        .element( 'subelement', terminalInteractionModel )
        .data( 'mouseCoord', this.gui.relativeMouseCoord(event) );

    return this.gui.stateMachine.handle(cEvent);
};
